import React from "react";
import { makeStyles } from "@material-ui/core/styles";
// import AppBar from "../../Components/header/index";
// import ForgotPass from "../../Components/Pages/Authentication/forgotpassword";
// import AppProvider from "./../../Components/bootstrap"
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { Form } from "react-final-form";
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
// import AppProvider from "./../../bootstrap/index";
import { useAuthProvider, useNotify, useRedirect, Notification } from "react-admin";
// import Box from "@material-ui/core/Box";
import AppBar from "../../Components/header/AuthenticationPageHeader"
import AppProvider from "../../Components/bootstrap/index"
import {
  validateForgotPasswordForm,
  ForgotPasswordForm
} from "../../Components/Pages/Authentication/ForgotPassword";
const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    // marginTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: 10,
    width: 300,
    height: 60,
    // margin: theme.spacing(1),
    backgroundColor: "white"
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  
  coverBackgroundContainer: {
    backgroundColor: "#F7F8F9",
    height: "100vh",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: "4%",
    paddingRight: "4%",
    paddingTop: "90px",
    // paddingBottom: "20px"
  }
}));

const ForgotPass = props => {
  const authProvider = useAuthProvider();
  const classes = useStyles();
  // const { handleSubmit } = props;
  const notify = useNotify();
  const redirect = useRedirect();

  console.log(authProvider);
  return (
    <div className={classes.coverBackgroundContainer}>
       <AppProvider >
      <Container
        component="main"
        maxWidth="xs"
        style={{ background: "#ffffff", marginTop: "15%",marginBottom:"20%"}}
      >
              <Notification/>

        
        <AppBar/>
        <div className={classes.paper}>
          <Typography component="h6" variant="h6" style={{ paddingTop: "14%"}}>
            Reset Your Password
          </Typography>

          <Form
            initialValues={{}}
            validate={validateForgotPasswordForm}
            onSubmit={response =>
              authProvider.resetPassword({ email: response.email, redirect, notify })
            }
            keepDirtyOnReinitialize
            render={ForgotPasswordForm}
          />
        </div>
        <Grid container >
            <Grid item xs={12} style={{textAlign:"center",marginTop:"3%",marginBottom:"15%"}}>
              <Link href="/login"  style={{ textDecoration: 'none',color:"#000000",}} >
                Remember your password? Login
              </Link>
            </Grid>
          </Grid>
      </Container>
      </AppProvider>
    </div>
  );
};
export default ForgotPass;




// import React from 'react';
// import AppBar from "../../Components/header/index";
// import ForgotPassword from "../../Components/Pages/Authentication/ForgotPassword"
// import AppProvider from "./../../Components/bootstrap"

// export default function Home() {
//     return (
//         <AppProvider>
//             <AppBar/>
//             {/* <ForgotPassword/> */}
//             {/* <Footer/> */}
//         </AppProvider>
//     );
// }
